import { render, staticRenderFns } from "./AuthenticationPopup.vue?vue&type=template&id=907a368c&scoped=true&"
import script from "./AuthenticationPopup.vue?vue&type=script&lang=js&"
export * from "./AuthenticationPopup.vue?vue&type=script&lang=js&"
import style0 from "./AuthenticationPopup.vue?vue&type=style&index=0&id=907a368c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907a368c",
  null
  
)

export default component.exports